<script>
    import { onMount } from "svelte";

    let totalcount = 0;
    let devcodes = [];

    // 提示框配置
    toastr.options = {
        positionClass: "toast-top-center",
    };

    // 加载事件函数
    onMount(() => {
        loadDevices();
    });

    function loadDevices() {
        let tmpUrl = "/rtapi/getdevlist";
        jQuery.ajax({
            type: "get",
            url: tmpUrl,
            success: function (response) {
                if (response.code == 200) {
                    if (Array.isArray(response.result)) {
                        devcodes = response.result;
                        totalcount = devcodes.length;
                    }
                }
            },
            error: function (err) {
                console.log(err);
            },
        });
    }
</script>

<!-- Content Wrapper. Contains page content -->
<div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1>数据看板</h1>
                </div>
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">&nbsp;</ol>
                </div>
            </div>
        </div>
    </section>
    <!-- Main content -->
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <!-- card -->
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">设备总数: {totalcount} 台</h3>
                            <div class="card-tools">
                                &nbsp;
                            </div>
                        </div>
                        <div class="card-body">
                            &nbsp;<br>
                            &nbsp;<br>
                            &nbsp;<br>
                            &nbsp;<br>
                            &nbsp;<br>
                            &nbsp;<br>
                            &nbsp;<br>
                        </div>
                    </div>
                    <!-- end of card -->
                </div>
            </div>
        </div>
    </section>
</div>
<style>
</style>
